import { defineMessages, useIntl } from 'react-intl';
import { Edit, Security, UserMultiple } from '@carbon/icons-react';

import InfoCard from 'Components/Common/InfoCard/InfoCard';

import churchImage from 'assets/images/church.png';
import styles from './ParishInfoCard.module.scss';
import cx from 'classnames';

const ParishInfoCard = ({
    className,
}: {
    className?: string;
}) => {
    const intl = useIntl();

    return (
        <div className={cx(styles.wrapper, className)}>
            <InfoCard
                img={churchImage}
                title={intl.formatMessage(messages.title)}
                description={intl.formatMessage(messages.description)}
                items={[
                    {
                        icon: <Security size={20} />,
                        title: intl.formatMessage(messages.securityTitle),
                        description: intl.formatMessage(messages.securityDescription),
                    },
                    {
                        icon: <Edit size={20} />,
                        title: intl.formatMessage(messages.editTitle),
                        description: intl.formatMessage(messages.editDescription),
                    },
                    {
                        icon: <UserMultiple size={20} />,
                        title: intl.formatMessage(messages.communityTitle),
                        description: intl.formatMessage(messages.communityDescription),
                    },
                ]}
            />
        </div>
    );
};

const messages = defineMessages({
    title: {
        id: 'src.Components.Common.ParishInfoCard.title',
        defaultMessage: 'Dlaczego to ważne?',
    },
    description: {
        id: 'src.Components.Common.ParishInfoCard.description',
        defaultMessage: 'Dzięki tym informacjom parafianie będą mogli łatwo znaleźć i skontaktować się z Waszą parafią.',
    },
    securityTitle: {
        id: 'src.Components.Common.ParishInfoCard.securityTitle',
        defaultMessage: 'Twoje dane są bezpieczne',
    },
    securityDescription: {
        id: 'src.Components.Common.ParishInfoCard.securityDescription',
        defaultMessage: 'Chronimy je zgodnie z najwyższymi standardami.',
    },
    editTitle: {
        id: 'src.Components.Common.ParishInfoCard.editTitle',
        defaultMessage: 'Zmienisz je w każdej chwili',
    },
    editDescription: {
        id: 'src.Components.Common.ParishInfoCard.editDescription',
        defaultMessage: 'Wszystkie ustawienia możesz edytować później.',
    },
    communityTitle: {
        id: 'src.Components.Common.ParishInfoCard.communityTitle',
        defaultMessage: 'Dla dobra wspólnoty',
    },
    communityDescription: {
        id: 'src.Components.Common.ParishInfoCard.communityDescription',
        defaultMessage: 'Ułatwiamy kontakt i budujemy wspólnotę parafialną.',
    },
});

export default ParishInfoCard;
